export const COMPANIES_CODE_TYPE = 'Companies';
export const DEMO_ENVIRONMENTS_CODE_TYPE = 'DemoEnvironments';
export const COMPANY_USERS_CODE_TYPE = 'CompanyUsers';
export const ALL_COMPANY_USERS_CODE_TYPE = 'AllCompanyUsers';
export const COMPANY_MANAGERS_CODE_TYPE = 'CompanyManagers';
export const COMPANY_ROLES_CODE_TYPE = 'CompanyRoles';
export const SEARCH_CODE_TYPE = 'Search';
